import {
    GET_ACTIVE_SERVICES_REQUEST,
    GET_ACTIVE_SERVICES_SUCCESS,
    GET_ACTIVE_SERVICES_FAILURE,
    GET_GPS_SUMMARY_REQUEST,
    GET_GPS_SUMMARY_SUCCESS,
    GET_GPS_SUMMARY_FAILURE,
    GET_GPS_REPORT_REQUEST,
    GET_GPS_REPORT_SUCCESS,
    GET_GPS_REPORT_FAILURE,
    GET_GPS_SUBSTATUS_TABLE_REPORT_REQUEST,
    GET_GPS_SUBSTATUS_TABLE_REPORT_SUCCESS,
    GET_GPS_SUBSTATUS_TABLE_REPORT_FAILURE,
    GET_TICKETS_SUMMARY_REQUEST,
    GET_TICKETS_SUMMARY_SUCCESS,
    GET_TICKETS_SUMMARY_FAILURE,
    GET_TICKETS_SUMMARY_GRAPH_REQUEST,
    GET_TICKETS_SUMMARY_GRAPH_SUCCESS,
    GET_TICKETS_SUMMARY_GRAPH_FAILURE,
    GET_SIMCARDS_REPORT_REQUEST,
    GET_SIMCARDS_REPORT_SUCCESS,
    GET_SIMCARDS_REPORT_FAILURE,
    GET_SIMCARDS_REPORT_FILTERED_REQUEST,
    GET_SIMCARDS_REPORT_FILTERED_SUCCESS,
    GET_SIMCARDS_REPORT_FILTERED_FAILURE,
    GET_DEVICES_REPORT_REQUEST,
    GET_DEVICES_REPORT_SUCCESS,
    GET_DEVICES_REPORT_FAILURE,
    GET_DEVICES_REPORT_FILTERED_REQUEST,
    GET_DEVICES_REPORT_FILTERED_SUCCESS,
    GET_DEVICES_REPORT_FILTERED_FAILURE,
    GET_AGENCIES_REQUEST,
    GET_AGENCIES_SUCCESS,
    GET_AGENCIES_FAILURE,
    GET_COMPANIES_REPORTS_REQUEST,
    GET_COMPANIES_REPORTS_SUCCESS,
    GET_COMPANIES_REPORTS_FAILURE,
    EXPORT_GPS_SUMMARY_REQUEST,
    EXPORT_GPS_SUMMARY_SUCCESS,
    EXPORT_GPS_SUMMARY_FAILURE,
    EXPORT_TICKETS_SUMMARY_REQUEST,
    EXPORT_TICKETS_SUMMARY_SUCCESS,
    EXPORT_TICKETS_SUMMARY_FAILURE,
    EXPORT_GPS_REPORT_REQUEST,
    EXPORT_GPS_REPORT_SUCCESS,
    EXPORT_GPS_REPORT_FAILURE,
    EXPORT_SIMCARDS_REPORT_REQUEST,
    EXPORT_SIMCARDS_REPORT_SUCCESS,
    EXPORT_SIMCARDS_REPORT_FAILURE,
    EXPORT_DEVICES_REPORT_REQUEST,
    EXPORT_DEVICES_REPORT_SUCCESS,
    EXPORT_DEVICES_REPORT_FAILURE,
    EXPORT_INVENTORY_REPORT_REQUEST,
    EXPORT_INVENTORY_REPORT_SUCCESS,
    EXPORT_INVENTORY_REPORT_FAILURE,
    SET_DATE_RANGE,
    SET_TICKETS_DATE_RANGE,
    GET_USER_SETTINGS_REQUEST,
    GET_USER_SETTINGS_SUCCESS,
    GET_USER_SETTINGS_FAILURE,
    SAVE_USER_SETTINGS_SUCCESS
} from "../actions/reports";

const initialState = {
    fetching: false,
    activeservices: null,
    totalActiveservices: 0,
    
    // GPS Summary
    gpsSummaryFetching: false,
    gpsSummary: null,
    
    // GPS Report
    gpsReportFetching: false,
    gpsReport: null,

    // GPS Substatus Table Report (filtered only for the table)
    gpsSubstatusTableReportFetching: false,
    gpsSubstatusTableReport: null,
    
    // Tickets Summary
    ticketsSummaryFetching: false,
    ticketsSummary: null,
    
    // Tickets Summary Graph (independent state)
    ticketsSummaryGraphFetching: false,
    ticketsSummaryGraph: null,
    
    // Simcards Report
    simcardsReportFetching: false,
    simcardsReport: null,
    
    // Simcards Report Filtered (for graph)
    simcardsReportFilteredFetching: false,
    simcardsReportFiltered: null,
    
    // Devices Report
    devicesReportFetching: false,
    devicesReport: null,
    
    // Devices Report Filtered (for graph)
    devicesReportFilteredFetching: false,
    devicesReportFiltered: null,
    
    // Agencies
    agenciesFetching: false,
    agencies: null,
    
    // Companies
    companiesFetching: false,
    companies: null,
    
    // Export states
    exportFetching: false,
    
    // Date Range
    dateRange: {
        range: 'Ahora',
        upToDate: new Date().toISOString()
    },

    // Tickets Date Range (startDate/endDate)
    ticketsDateRange: {
        range: 'Esta semana',
        startDate: null,
        endDate: null
    },

    // User Settings (saved filters), keyed by screen name
    userSettingsByScreen: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ACTIVE_SERVICES_REQUEST: {
            return {
                ...state,
                fetching: true,
                activeservices: null
            };
        }
        case GET_ACTIVE_SERVICES_SUCCESS: {
            return {
                ...state,
                fetching: false,
                activeservices: action.payload.activeservices,
                totalActiveservices: action.payload.total
            };
        }
        case GET_ACTIVE_SERVICES_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        
        // GPS Summary
        case GET_GPS_SUMMARY_REQUEST: {
            return {
                ...state,
                gpsSummaryFetching: true
            };
        }
        case GET_GPS_SUMMARY_SUCCESS: {
            return {
                ...state,
                gpsSummaryFetching: false,
                gpsSummary: action.payload.summary
            };
        }
        case GET_GPS_SUMMARY_FAILURE: {
            return {
                ...state,
                gpsSummaryFetching: false
            };
        }
        
        // GPS Report
        case GET_GPS_REPORT_REQUEST: {
            return {
                ...state,
                gpsReportFetching: true
            };
        }
        case GET_GPS_REPORT_SUCCESS: {
            return {
                ...state,
                gpsReportFetching: false,
                gpsReport: action.payload.data
            };
        }
        case GET_GPS_REPORT_FAILURE: {
            return {
                ...state,
                gpsReportFetching: false
            };
        }

        // GPS Substatus Table Report
        case GET_GPS_SUBSTATUS_TABLE_REPORT_REQUEST: {
            return {
                ...state,
                gpsSubstatusTableReportFetching: true
            };
        }
        case GET_GPS_SUBSTATUS_TABLE_REPORT_SUCCESS: {
            return {
                ...state,
                gpsSubstatusTableReportFetching: false,
                gpsSubstatusTableReport: action.payload.data
            };
        }
        case GET_GPS_SUBSTATUS_TABLE_REPORT_FAILURE: {
            return {
                ...state,
                gpsSubstatusTableReportFetching: false
            };
        }
        
        // Tickets Summary
        case GET_TICKETS_SUMMARY_REQUEST: {
            return {
                ...state,
                ticketsSummaryFetching: true
            };
        }
        case GET_TICKETS_SUMMARY_SUCCESS: {
            return {
                ...state,
                ticketsSummaryFetching: false,
                ticketsSummary: action.payload.summary
            };
        }
        case GET_TICKETS_SUMMARY_FAILURE: {
            return {
                ...state,
                ticketsSummaryFetching: false
            };
        }
        
        // Tickets Summary Graph (independent)
        case GET_TICKETS_SUMMARY_GRAPH_REQUEST: {
            return {
                ...state,
                ticketsSummaryGraphFetching: true
            };
        }
        case GET_TICKETS_SUMMARY_GRAPH_SUCCESS: {
            return {
                ...state,
                ticketsSummaryGraphFetching: false,
                ticketsSummaryGraph: action.payload.summary
            };
        }
        case GET_TICKETS_SUMMARY_GRAPH_FAILURE: {
            return {
                ...state,
                ticketsSummaryGraphFetching: false
            };
        }
        
        // Simcards Report
        case GET_SIMCARDS_REPORT_REQUEST: {
            return {
                ...state,
                simcardsReportFetching: true
            };
        }
        case GET_SIMCARDS_REPORT_SUCCESS: {
            return {
                ...state,
                simcardsReportFetching: false,
                simcardsReport: action.payload.data
            };
        }
        case GET_SIMCARDS_REPORT_FAILURE: {
            return {
                ...state,
                simcardsReportFetching: false
            };
        }
        
        // Simcards Report Filtered
        case GET_SIMCARDS_REPORT_FILTERED_REQUEST: {
            return {
                ...state,
                simcardsReportFilteredFetching: true
            };
        }
        case GET_SIMCARDS_REPORT_FILTERED_SUCCESS: {
            return {
                ...state,
                simcardsReportFilteredFetching: false,
                simcardsReportFiltered: action.payload.data
            };
        }
        case GET_SIMCARDS_REPORT_FILTERED_FAILURE: {
            return {
                ...state,
                simcardsReportFilteredFetching: false
            };
        }
        
        // Devices Report
        case GET_DEVICES_REPORT_REQUEST: {
            return {
                ...state,
                devicesReportFetching: true
            };
        }
        case GET_DEVICES_REPORT_SUCCESS: {
            return {
                ...state,
                devicesReportFetching: false,
                devicesReport: action.payload.data
            };
        }
        case GET_DEVICES_REPORT_FAILURE: {
            return {
                ...state,
                devicesReportFetching: false
            };
        }
        
        // Devices Report Filtered
        case GET_DEVICES_REPORT_FILTERED_REQUEST: {
            return {
                ...state,
                devicesReportFilteredFetching: true
            };
        }
        case GET_DEVICES_REPORT_FILTERED_SUCCESS: {
            return {
                ...state,
                devicesReportFilteredFetching: false,
                devicesReportFiltered: action.payload.data
            };
        }
        case GET_DEVICES_REPORT_FILTERED_FAILURE: {
            return {
                ...state,
                devicesReportFilteredFetching: false
            };
        }
        
        // Agencies
        case GET_AGENCIES_REQUEST: {
            return {
                ...state,
                agenciesFetching: true
            };
        }
        case GET_AGENCIES_SUCCESS: {
            return {
                ...state,
                agenciesFetching: false,
                agencies: action.payload.data
            };
        }
        case GET_AGENCIES_FAILURE: {
            return {
                ...state,
                agenciesFetching: false
            };
        }
        
        // Companies
        case GET_COMPANIES_REPORTS_REQUEST: {
            return {
                ...state,
                companiesFetching: true
            };
        }
        case GET_COMPANIES_REPORTS_SUCCESS: {
            return {
                ...state,
                companiesFetching: false,
                companies: action.payload.data
            };
        }
        case GET_COMPANIES_REPORTS_FAILURE: {
            return {
                ...state,
                companiesFetching: false
            };
        }
        
        // Export GPS Summary
        case EXPORT_GPS_SUMMARY_REQUEST: {
            return {
                ...state,
                exportFetching: true
            };
        }
        case EXPORT_GPS_SUMMARY_SUCCESS: {
            return {
                ...state,
                exportFetching: false
            };
        }
        case EXPORT_GPS_SUMMARY_FAILURE: {
            return {
                ...state,
                exportFetching: false
            };
        }
        
        // Export Tickets Summary
        case EXPORT_TICKETS_SUMMARY_REQUEST: {
            return {
                ...state,
                exportFetching: true
            };
        }
        case EXPORT_TICKETS_SUMMARY_SUCCESS: {
            return {
                ...state,
                exportFetching: false
            };
        }
        case EXPORT_TICKETS_SUMMARY_FAILURE: {
            return {
                ...state,
                exportFetching: false
            };
        }
        
        // Export GPS Report
        case EXPORT_GPS_REPORT_REQUEST: {
            return {
                ...state,
                exportFetching: true
            };
        }
        case EXPORT_GPS_REPORT_SUCCESS: {
            return {
                ...state,
                exportFetching: false
            };
        }
        case EXPORT_GPS_REPORT_FAILURE: {
            return {
                ...state,
                exportFetching: false
            };
        }
        
        // Export Simcards Report
        case EXPORT_SIMCARDS_REPORT_REQUEST: {
            return {
                ...state,
                exportFetching: true
            };
        }
        case EXPORT_SIMCARDS_REPORT_SUCCESS: {
            return {
                ...state,
                exportFetching: false
            };
        }
        case EXPORT_SIMCARDS_REPORT_FAILURE: {
            return {
                ...state,
                exportFetching: false
            };
        }
        
        // Export Devices Report
        case EXPORT_DEVICES_REPORT_REQUEST: {
            return {
                ...state,
                exportFetching: true
            };
        }
        case EXPORT_DEVICES_REPORT_SUCCESS: {
            return {
                ...state,
                exportFetching: false
            };
        }
        case EXPORT_DEVICES_REPORT_FAILURE: {
            return {
                ...state,
                exportFetching: false
            };
        }
        
        // Export Unified Inventory Report
        case EXPORT_INVENTORY_REPORT_REQUEST: {
            return {
                ...state,
                exportFetching: true
            };
        }
        case EXPORT_INVENTORY_REPORT_SUCCESS: {
            return {
                ...state,
                exportFetching: false
            };
        }
        case EXPORT_INVENTORY_REPORT_FAILURE: {
            return {
                ...state,
                exportFetching: false
            };
        }
        
        // Date Range
        case SET_DATE_RANGE: {
            return {
                ...state,
                dateRange: {
                    range: action.payload.range,
                    upToDate: action.payload.upToDate
                }
            };
        }

        // Tickets Date Range
        case SET_TICKETS_DATE_RANGE: {
            return {
                ...state,
                ticketsDateRange: {
                    range: action.payload.range,
                    startDate: action.payload.startDate,
                    endDate: action.payload.endDate
                }
            };
        }

        // User Settings (saved filters)
        case GET_USER_SETTINGS_REQUEST: {
            const { screen } = action.payload;
            return {
                ...state,
                userSettingsByScreen: {
                    ...state.userSettingsByScreen,
                    [screen]: { ...(state.userSettingsByScreen[screen] || {}), fetching: true }
                }
            };
        }
        case GET_USER_SETTINGS_SUCCESS: {
            const { screen, settings } = action.payload;
            return {
                ...state,
                userSettingsByScreen: {
                    ...state.userSettingsByScreen,
                    [screen]: { fetching: false, data: settings }
                }
            };
        }
        case GET_USER_SETTINGS_FAILURE: {
            const { screen } = action.payload;
            return {
                ...state,
                userSettingsByScreen: {
                    ...state.userSettingsByScreen,
                    [screen]: { ...(state.userSettingsByScreen[screen] || {}), fetching: false }
                }
            };
        }
        case SAVE_USER_SETTINGS_SUCCESS: {
            const { screen, settings } = action.payload;
            return {
                ...state,
                userSettingsByScreen: {
                    ...state.userSettingsByScreen,
                    [screen]: { ...(state.userSettingsByScreen[screen] || {}), data: settings }
                }
            };
        }

        default:
            return state;
    }
};
